import * as Yup from 'yup';
import { getRequiredMessage } from 'views/declarations/utils/validation-utils';

export const documentFormValidationSchemaCommon = {
    filename: Yup.string().trim().required(getRequiredMessage('fileName')),
    documentType: Yup.string().trim().required(getRequiredMessage('documentType')),
};

export const documentFormValidationSchemaAis = {
    documentIdentifier: Yup.string().trim().required(getRequiredMessage('documentIdentifier')),
    documentReference: Yup.string().trim().required(getRequiredMessage('documentReference')),
    documentDescription: Yup.string().trim().required(getRequiredMessage('documentDescription')),
};

export const documentFormValidationSchemaAes = {
    description: Yup.string().trim().required(getRequiredMessage('description')),
    documentComplementaryInformation: Yup.string()
        .trim()
        .required(getRequiredMessage('documentComplementaryInformation')),
};

export const documentFormValidationSchemaNcts = {
    documentComplementaryInformation: Yup.string()
        .trim()
        .required(getRequiredMessage('documentComplementaryInformation')),
    description: Yup.string().trim().required(getRequiredMessage('description')),
};
